import {
  LinkButton,
  Button,
  ButtonStyle,
  SideImageLayout,
  Banner,
} from '@versita/frontend/campus-ui-web';
import { useUserWidget } from '../../hooks/useUserWidget';
import loginImage from '../../assets/img/login_splash.png';
import { useLocation } from 'react-router-dom';
import { loginContent as content } from '@versita/shared/text-content';

export const Login = () => {
  const userWidget = useUserWidget();
  const location = useLocation();
  const isRedirected =
    !location.pathname.includes('login') && location.pathname !== '/';
  return (
    <>
      {isRedirected && <Banner>{content.banner}</Banner>}
      <SideImageLayout
        userWidget={userWidget}
        heading={{ title: 'My Timetable' }}
        image={loginImage}
      >
        <p>
          <big>
            {content.prompt[0]}
            <a href={content.prompt[1].href} target="_blank" rel="noreferrer">
              {content.prompt[1].text}
            </a>{' '}
            {content.prompt[2]}
          </big>
        </p>
        <Button data-testid="login-cta" onClick={userWidget.login} $fullWidth>
          {content.loginButton}
        </Button>
        <p>
          <big>{content.courseTimetablePrompt}</big>
        </p>
        <LinkButton
          to="/courses"
          $buttonStyle={ButtonStyle.Secondary}
          $fullWidth
          data-testid="course-timetable-button"
        >
          {content.courseTimetableButton}
        </LinkButton>
        <h2>{content.whatIsCourseTimetableHeading}</h2>
        <p>{content.whatIsCourseTimetableBody}</p>
        <h2>{content.newStudentInfoHeading}</h2>
        <p>
          {content.newStudentInfoBody[0]}
          <a
            href={content.newStudentInfoBody[1].href}
            target="_blank"
            rel="noreferrer"
          >
            {content.newStudentInfoBody[1].text}
          </a>
          .
        </p>
      </SideImageLayout>
    </>
  );
};

export default Login;
